import * as React from 'react';

const PageNotFound = () => <h1 className="container level-item">404 - page not found</h1>;

export default PageNotFound;
